import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { childrenOfType } from 'airbnb-prop-types';
import ThemeConsumer from '@sitebase/theme-context/es/ThemeConsumer';


import SelectNative from './SelectNative';
import SelectOption from './SelectOption';
import propTypeClassName from '../propTypeClassName';
import { makeOutfitParser, category } from '../outfit-parser';
import outfitPropValidator from '../outfitPropValidator';

var sizesList = ['tiny', 'small', 'normal', 'base', 'large', 'x-large'];
var statusesList = ['error', 'success'];

var parseOutfit = makeOutfitParser(category('size', sizesList), category('status', statusesList));

var getOutfitProps = function getOutfitProps(outfit) {
  var parsedOutfit = parseOutfit(outfit);

  var _parsedOutfit$get = parsedOutfit.get('size'),
      _parsedOutfit$get2 = _slicedToArray(_parsedOutfit$get, 1),
      _parsedOutfit$get2$ = _parsedOutfit$get2[0],
      size = _parsedOutfit$get2$ === undefined ? 'normal' : _parsedOutfit$get2$;

  var _parsedOutfit$get3 = parsedOutfit.get('status'),
      _parsedOutfit$get4 = _slicedToArray(_parsedOutfit$get3, 1),
      _parsedOutfit$get4$ = _parsedOutfit$get4[0],
      status = _parsedOutfit$get4$ === undefined ? '' : _parsedOutfit$get4$;

  return { size: size, status: status };
};

var NativeSelect = function (_Component) {
  _inherits(NativeSelect, _Component);

  function NativeSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NativeSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NativeSelect.__proto__ || _Object$getPrototypeOf(NativeSelect)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
      if (typeof _this.selectComponent.focus === 'function') _this.selectComponent.focus();
    }, _this.storeRef = function (ref) {
      _this.selectComponent = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NativeSelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _getOutfitProps = getOutfitProps(this.props.outfit),
          size = _getOutfitProps.size,
          status = _getOutfitProps.status;

      return React.createElement(
        ThemeConsumer,
        null,
        function (theme) {
          return React.createElement(SelectNative, _extends({
            ref: _this2.storeRef,
            status: status,
            theme: theme,
            size: size
          }, _this2.props));
        }
      );
    }
  }]);

  return NativeSelect;
}(Component);

NativeSelect.propTypes = {
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   *
   * Options:
   *
   *    - Sizes:
   *      - "**tiny**"
   *      - "**small**"
   *      - "**normal**"
   *      - "**base**"
   *      - "**large**"
   *      - "**x-large**"
   *    - Statuses: (adds appropriate coloring)
   *      - "**error**"
   *      - "**success**"
   */
  outfit: outfitPropValidator([].concat(sizesList, statusesList)),
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName,
  /** Disables the input if set to true */
  disabled: PropTypes.bool,
  /** Specifies that the user is required to select a value before submitting the form */
  required: PropTypes.bool,
  /** Value of option to select. Use it for controlled mode */
  value: PropTypes.string,
  /** Default value of option to select. Use it for uncontrolled mode */
  defaultValue: PropTypes.string,
  /** The Select children - accepts only <SelectOption /> */
  children: childrenOfType(SelectOption),
  /** Callback function that is fired when the selected option has changed */
  onChange: PropTypes.func,
  /** Callback function that is fired on blur */
  onBlur: PropTypes.func,
  /** Callback function that is fired on focus */
  onFocus: PropTypes.func,
  /** Callback function that is fired on submit */
  onSubmit: PropTypes.func,
  /** Callback function that is fired on click */
  onClick: PropTypes.func,
  /** Callback function that is fired on mouse down */
  onMouseDown: PropTypes.func,
  /** Callback function that is fired on mouse move */
  onMouseMove: PropTypes.func,
  /** Callback function that is fired on mouse out */
  onMouseOut: PropTypes.func,
  /** Callback function that is fired on mouse over */
  onMouseOver: PropTypes.func,
  /** Callback function that is fired on mouse up */
  onMouseUp: PropTypes.func,
  /** Placeholder option text */
  placeholder: PropTypes.string
};
NativeSelect.defaultProps = {
  outfit: 'normal'
};
export default NativeSelect;